SlideView = require("views/slide")

class QuestionPoolView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"

module.exports = QuestionPoolView
